// eslint-disable-next-line no-undef
const ajax_object = KLAVAN_ajax_object

// Use an object to track page numbers for different page functions
const pageCounters = {
  getMembersData: 2,
  getNewsPosts: 2,
}

// Function to reset the pagination counter
const resetPagination = (pageFunction) => {
  // If pageFunction is specified, reset that specific counter
  if (pageFunction) {
    pageCounters[pageFunction] = 2
  } else {
    // By default, only reset members pagination
    pageCounters.getMembersData = 2
  }

  // Show pagination again if it was hidden
  const pagination = document.querySelector(".pagination")
  if (pagination) pagination.style.display = ""
}

// Make the function globally accessible
window.resetKlavanPagination = resetPagination

const getMoreItems = async ({ maxPages, pageFunction, container }) => {
  const formData = new FormData()
  formData.append("action", pageFunction)
  formData.append("page", pageCounters[pageFunction])

  try {
    // Fetch data
    const response = await fetch(ajax_object.ajax_url, {
      method: "POST",
      body: formData,
    })

    const data = await response.json()

    // Create new elements from HTML string
    const tempContainer = document.createElement("div")
    tempContainer.innerHTML = data.data
    const newItems = Array.from(tempContainer.children)

    // Append new items to the appropriate container
    const targetContainer = document.querySelector(container)
    if (!targetContainer) {
      console.error(`Container ${container} not found`)
      return
    }

    newItems.forEach((item) => {
      targetContainer.appendChild(item)
    })

    // Find the pagination element that's a sibling of the current container
    const pagination = targetContainer
      .closest("section")
      .querySelector(".pagination")

    if (pageCounters[pageFunction] >= Number(maxPages)) {
      if (pagination) pagination.style.display = "none"
    }

    pageCounters[pageFunction]++
  } catch (error) {
    console.error("Error loading more items:", error)
    const errorMessage = document.createElement("h2")
    errorMessage.textContent = `Error: ${error.message}`
    document.querySelector(".pagination").appendChild(errorMessage)
  }
}

// Initialize once DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  const loadMoreButtons = document.querySelectorAll(".js-get-more-items")

  loadMoreButtons.forEach((button) => {
    const maxPages = button.dataset.maxPages
    const pageFunction = button.dataset.function

    // Initialize page counter if it doesn't exist
    if (!pageCounters[pageFunction]) {
      pageCounters[pageFunction] = 2
    }

    if (maxPages === "1") {
      const pagination = button.closest(".pagination")
      if (pagination) pagination.style.display = "none"
    }
  })
})

// Event delegation for the load more button
document.addEventListener("click", (event) => {
  if (!event.target.closest(".js-get-more-items")) return

  const loadMoreButton = event.target.closest(".js-get-more-items")
  const maxPages = loadMoreButton.dataset.maxPages
  const pageFunction = loadMoreButton.dataset.function
  const container = loadMoreButton.dataset.container || ".post-list" // Default to .post-list if not specified

  getMoreItems({
    maxPages,
    pageFunction,
    container,
  })
})
